import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import { Form, Headings, Input, Padding } from '../../components'

function DatesRange({ from, setFrom, setTo, t, to }) {
    return (
        <Padding>
            <Padding bottom>
                <Headings.H2>{t('reports-dates')}</Headings.H2>
            </Padding>
            <Form.Label id="date_start" label={t('date-start')}>
                <Input id="date-start" type="date" onChange={setFrom} value={from} />
            </Form.Label>
            <Form.Label id="date-end" label={t('date-end')}>
                <Input id="date-end" type="date" onChange={setTo} value={to} />
            </Form.Label>
        </Padding>
    )
}

DatesRange.propTypes = {
    from: PropTypes.number,
    setFrom: PropTypes.func,
    setTo: PropTypes.func,
    t: PropTypes.func,
    to: PropTypes.number,
}

DatesRange.defaultProps = {
    from: 0,
    setFrom: () => null,
    setTo: () => null,
    t: () => null,
    to: 0,
}

export default withTranslation()(DatesRange)
